// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBars } from '@ni/nimble-components/dist/esm/icons/bars';
import { wrap } from '../utilities/react-wrapper';

export { type IconBars };
export const NimbleIconBars = wrap(IconBars);